
const mentionsRegex = /\B@\[([a-zA-Z\s]+)\]\(([A-Z0-9\-]+)\)\B/i;
if(!String.prototype.trim){  
  String.prototype.trim = function(){  
    return this.replace(/^\s+|\s+$/g,'');  
  };  
}

export function humanizeCamelCase(s) {
   return s.replace(/([A-Z])/g, ' $1')
    // uppercase the first character
    .replace(/^./, function(str){ return str.toUpperCase(); });
}

export function capatilizeWords(s){
	return s.replace(/^./, function(str){ return str.toUpperCase(); });
}

export function parseMentionsWithAnchor(text){		
	try {				
		var parsedMatch = text;		
		var match;	
		while(match = parsedMatch.match(mentionsRegex)){			
			var employee_id = match[2];
			var name = match[1];
	        // console.log("Matching ", employee_id, name);
			parsedMatch = parsedMatch.replace(match[0], "<a href=\"/teams/user/" + employee_id + "\">@" + name + "</a>");
		}
	} catch(err){
		console.error('Parse mentions error:' + err)
	}	
	
	return  parsedMatch;
}

export function getMentionedUserIds(text){
	try {
		var mentionedUsers = [];
		var match;
		var parsedMatch = text;
		while(match = parsedMatch.match(mentionsRegex)){
			var employee_id = match[2];
			mentionedUsers.push(employee_id);
			parsedMatch = parsedMatch.replace(match[0], '@' + match[1]);
		}

	} catch (err){
		console.error('Parse mentions error:' + err);
	}
	
	return mentionedUsers;
}

export function formatPhoneString(text){
	if (text.match(/(\d\d\d)(\d\d\d)(\d\d\d\d)/)){
		return text.replace(/(\d\d\d)(\d\d\d)(\d\d\d\d)/, '$1 $2 $3');
	}

	if (text.match(/(\d\d\d)(\d\d\d)(\d\d\d)/)){
		return text.replace(/(\d\d\d)(\d\d\d)(\d\d\d)/, '$1 $2 $3');
	}

	return text.replace(/(\d\d\d)(\d\d\d\d)/, '$1 $2');	
}


// WEBPACK FOOTER //
// ./app/utils/StringUtils.js